/**
 * Lunere AJAX add-to-cart — adds items via /cart/add.js and opens the cart drawer.
 * Preserves selling_plan (subscriptions) and other form fields on PDP submit.
 */
(function () {
  if (window.__lunereAtcInitialized) return;
  window.__lunereAtcInitialized = true;

  var CART_UPDATE = 'cart:update';

  function getCartAddUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
  }

  function getSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function appendSections(formData) {
    var sectionIds = getSectionIds();
    if (!sectionIds.length) return;
    formData.append('sections', sectionIds.join(','));
    formData.append('sections_url', window.location.pathname);
  }

  function dispatchCartUpdate(resource, sourceId, data) {
    document.dispatchEvent(
      new CustomEvent(CART_UPDATE, {
        bubbles: true,
        detail: {
          resource: resource || {},
          sourceId: String(sourceId || ''),
          data: data || {},
        },
      })
    );
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else if (typeof drawer.showDialog === 'function') {
      drawer.showDialog();
    }
  }

  /**
   * @param {FormData} formData
   * @param {HTMLElement} [trigger]
   * @returns {Promise<void>}
   */
  async function addFormDataToCart(formData, trigger) {
    var variantId = formData.get('id');
    if (!variantId) throw new Error('Variant ID is required');

    var qty = Math.max(1, Number(formData.get('quantity')) || 1);
    var sellingPlan = formData.get('selling_plan');

    // Drop empty selling_plan so one-time purchase stays one-time
    if (!sellingPlan) {
      formData.delete('selling_plan');
    }

    appendSections(formData);

    if (trigger) trigger.setAttribute('aria-busy', 'true');

    try {
      var response = await fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      var data = await response.json();

      if (data.status) {
        dispatchCartUpdate(data, variantId, {
          didError: true,
          source: 'product-form-component',
          itemCount: qty,
          variantId: String(variantId),
          sections: data.sections,
        });
        throw new Error(data.description || data.message || 'Could not add to cart');
      }

      dispatchCartUpdate(data, variantId, {
        source: 'product-form-component',
        itemCount: qty,
        variantId: String(variantId),
        sections: data.sections,
      });

      openCartDrawer();
    } finally {
      if (trigger) trigger.removeAttribute('aria-busy');
    }
  }

  /**
   * @param {string|number} variantId
   * @param {number} quantity
   * @param {HTMLElement} [trigger]
   * @param {string|number|null} [sellingPlan]
   * @returns {Promise<void>}
   */
  async function addToCart(variantId, quantity, trigger, sellingPlan) {
    if (!variantId) throw new Error('Variant ID is required');

    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(Math.max(1, Number(quantity) || 1)));

    if (sellingPlan) {
      formData.append('selling_plan', String(sellingPlan));
    }

    return addFormDataToCart(formData, trigger);
  }

  function resolveSellingPlan(form) {
    var values = [];

    if (form) {
      form.querySelectorAll('[name="selling_plan"]').forEach(function (input) {
        if (input.value) values.push(input.value);
      });
    }

    document.querySelectorAll('kaching-subscriptions [name="selling_plan"], [name="selling_plan"]').forEach(function (input) {
      if (input.value) values.push(input.value);
    });

    // Prefer the last non-empty value (widget may update a later input)
    return values.length ? values[values.length - 1] : '';
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lunere-atc]');
    if (!button || button.disabled) return;

    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    var quantity = button.getAttribute('data-quantity') || 1;
    var sellingPlan = button.getAttribute('data-selling-plan') || '';

    addToCart(variantId, quantity, button, sellingPlan).catch(function (error) {
      console.error('[lunere-atc]', error);
      window.alert(error.message || 'Could not add to cart');
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-lunere-atc-form')) return;

    event.preventDefault();

    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput && idInput.value;
    var submitter = event.submitter || form.querySelector('[type="submit"]');

    if (!variantId || (idInput && idInput.disabled)) return;

    var formData = new FormData(form);
    var sellingPlan = resolveSellingPlan(form);

    formData.delete('selling_plan');
    if (sellingPlan) {
      formData.set('selling_plan', sellingPlan);
    }

    addFormDataToCart(formData, submitter).catch(function (error) {
      console.error('[lunere-atc]', error);
      window.alert(error.message || 'Could not add to cart');
    });
  });

  window.LunereAddToCart = { add: addToCart, addFormData: addFormDataToCart };
})();
